// export default function Page(){
//   return (
//     <div className="page">
//       <h1>Facility Management Service 1</h1>
//       <p>Dummy content for Facility Management Service 1.</p>
//       <img src="https://via.placeholder.com/800x300" alt="dummy"/>
//     </div>
//   );
// }
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../styles/services.css";

import heroImg from "../../assets/images/Facilities-Management.jpg";
import img1 from "../../assets/images/Cleaning-Services.jpg";
import img2 from "../../assets/images/Car-Rental.jpg";
// import img3 from "../../assets/images/Event-Decorations.jpg";
import img3 from "../../assets/images/Housekeeping.jpg";

const Services = () => {
  const location = useLocation();

  // Scroll to section when URL has #id
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace("#", ""));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="services-page">
      {/* HERO */}
      <section className="services-hero">
        <div className="services-hero-left">
          <h1>Facilities Management by COLIPS</h1>
          <p>
            At COLIPS, we deliver integrated facilities management solutions
            designed to keep your environments safe, efficient, and running
            smoothly. From commercial premises to residential properties and
            event venues, our tailored services ensure seamless operations while
            you focus on what matters most.
          </p>
          <a href="#clearances" className="srv-btn">
            Get In Touch
          </a>
        </div>

        <div className="services-hero-right">
          <img src={heroImg} alt="" />
        </div>
      </section>

      {/* CLEARANCES */}
      <section id="cleaningservices" className="srv-section">
        <div className="srv-img">
          <img src={img1} alt="" />
        </div>
        <div className="srv-content">
          <h2>Cleaning Services</h2>
          <p>
            COLIPS provides comprehensive cleaning solutions that meet the
            highest standards of hygiene and presentation. Our trained
            professionals use industry-approved methods and eco-friendly
            products to maintain spotless, healthy spaces. We offer daily,
            weekly, and bespoke cleaning schedules for offices, retail spaces,
            venues, and residential properties. From routine maintenance to deep
            cleaning, we ensure every environment reflects professionalism and
            care.
          </p>
        </div>
      </section>

      {/* CLEANING */}
      <section id="eventdecorations" className="srv-banner">
        <div className="overlay">
          <h2>Event Decorations</h2>
          <p>
            Create memorable experiences with COLIPS event decoration services.
            We work closely with clients to design, plan, and execute décor that
            aligns with your theme, brand, and vision. Whether it’s a corporate
            event, private celebration, or large-scale function, our team
            manages everything from setup to takedown, ensuring a polished and
            visually impactful result without stress or disruption.
          </p>
        </div>
      </section>

      {/* FACILITIES */}
      <section id="carrental" className="srv-section reverse">
        <div className="srv-img">
          <img src={img2} alt="" />
        </div>
        <div className="srv-content">
          <h2>Car Rental</h2>
          <p>
            Our car rental service offers reliable, well-maintained vehicles to
            support business operations, events, and personal requirements.
            COLIPS ensures flexibility, comfort, and safety across our vehicle
            options. From short-term hires to scheduled transport solutions, we
            provide dependable service backed by professional support, making
            mobility simple and hassle-free.
          </p>
        </div>
      </section>

      {/* PRESSURE */}
      <section id="dogwalker" className="srv-banner dark">
        <div className="overlay">
          <h2>Dog Walker</h2>
          <p>
            COLIPS understands that pets are part of the family. Our dog walking
            service is designed to support busy owners by ensuring pets receive
            regular exercise, attention, and care. Handled by trusted and
            experienced staff, we offer flexible walking schedules tailored to
            your dog’s needs, giving you peace of mind while keeping your pet
            happy and healthy.
          </p>
        </div>
      </section>

      {/* DOG */}
      <section id="housekeeping" className="srv-section">
        <div className="srv-img">
          <img src={img3} alt="" />
        </div>
        <div className="srv-content">
          <h2>House Keeping</h2>
          <p>
            Our housekeeping services are designed to maintain comfort,
            cleanliness, and order in residential and serviced environments.
            COLIPS delivers consistent, high-quality housekeeping tailored to
            your lifestyle or property requirements. From daily upkeep to
            scheduled deep cleans, our discreet and professional team ensures
            your space remains welcoming, organised, and impeccably maintained.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Services;
